import ApiClient from '@/api/apiClient';
import { Activation, User } from '@/services/types';

class RegisterService {
    async register(data: User) {
        const url: string = `/register`;
        const defaultValue = null;
        const errorPath: string = '[api:account:register]';
        return await ApiClient.guest.post(url, defaultValue, errorPath, data);
    }
    async activate(data: Activation) {
        const url: string = `/activate`;
        const defaultValue = null;
        const errorPath: string = '[api:account:activate]';
        return await ApiClient.guest.post(url, defaultValue, errorPath, data);
    }
    async sendCode(email: string) {
        const url: string = `/send-code`;
        const defaultValue = null;
        const errorPath: string = '[api:account:sendCode]';
        return await ApiClient.guest.post(url, defaultValue, errorPath, { email });
    }
}

export default new RegisterService();
